module.exports = __webpack_public_path__ + "media/images/icons/scheda_verifica_tipologia-13f1dfa9282c90039d65f5f1a566e44d.svg";